
export default function Error() {

    return <div className="sec container d-flex align-items-center justify-content-center">
       Page not done yet 
  </div>
}